export default {
  buttons: {
    add: 'Add',
  },
  AddOn: {
    label: 'Add-on',
    title: 'Get your mobile app',
    subscribed: 'Subscribed',
    cta: 'Get your mobile app',
    price_per_month: '{{price}} / month',
    tax_included: 'incl. applicable tax',
    apple_developer_note:
      'Requires an Apple Developer account ($99/year, paid to Apple) in the restaurant’s legal entity.',
    features: {
      stores: 'Listed on the App Store and Google Play',
      push: 'Push notifications to your guests',
      loyalty: 'Loyalty points and rewards',
      commission: 'Direct ordering with 0% commission',
    },
  },
};
